<!-- <div>
  <div class="container-fluid">
    <div class="hp-sidenav">
      <div class="nav">
        <nav>
          <a href="javascript:void(0);" class="mobile-menu-trigger">
            <i class="bi bi-text-left fs-6"></i>
          </a>
        
          <ul class="menu menu-bar" *ngIf="isAuthenticated">
            <li
              *ngFor="let item of menuItems; let i = index"
              [class.open]="isOpen(i)"
              (mouseenter)="setOpen(i)"
              (mouseleave)="closeMenu()"
            >
          
              <a
                href="javascript:void(0)"
                *ngIf="item.children.length === 0 && item.isVisible"
                [routerLink]="[item.menuLink]"
                (click)="closeMenu()"
                class="menu-link menu-bar-link"
                aria-haspopup="false"
              >
                <i class="{{ item.className }}"></i> {{ item.menuName }}
              </a>
          
      
              <a
                href="javascript:void(0)"
                *ngIf="item.children.length > 0 && item.isVisible"
                class="menu-link menu-bar-link"
                aria-haspopup="true"
              >
                <i class="{{ item.className }}"></i> {{ item.menuName }}
              </a>
          
              <ul class="mega-menu mega-menu--multiLevel" *ngIf="item.children.length > 0  && item.isVisible">
                <li *ngFor="let child of getVisibleMenu(item)">
           
                  <a
                    href="javascript:void(0)"
                    *ngIf="child.children.length === 0  && child.isVisible"
                    [routerLink]="[child.menuLink]"
                    (click)="closeMenu()"
                    class="menu-link mega-menu-link"
                  >
                    {{ child.menuName }}
                  </a>
          
                
                  <ng-container *ngIf="child.children.length > 0  && child.isVisible">
                    <a
                      href="javascript:void(0)"
                      class="menu-link mega-menu-link"
                      aria-haspopup="true"
                    >
                      {{ child.menuName }}
                    </a>
                    <ul class="menu menu-list">
                      <li *ngFor="let child3 of child.children">
                        <a
                          [routerLink]="[child3.menuLink]"
                          (click)="closeMenu()"
                          class="menu-link menu-list-link"
                        >
                          {{ child3.menuName }}
                        </a>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </li>
          </ul>
          


                                
                  <ul class="menu menu-bar" *ngIf="!isAuthenticated">
                    <li>
                      <a [routerLink]="['/home']" class="menu-link menu-bar-link" (click)="closeMenu()">
                        <i class="bi bi-house-door"></i> Home
                      </a>
                    </li>
                  
                    <li [class.open]="isOpen(0)" (mouseenter)="setOpen(0)" (mouseleave)="closeMenu()">
                      <a href="javascript:void(0);" class="menu-link menu-bar-link" aria-haspopup="true">
                        <i class="bi bi-flag-fill"></i> About Department
                      </a>
                      <ul class="mega-menu mega-menu--multiLevel">
                        <li>
                          <a [routerLink]="['/aboutdepartment/structure']" (click)="closeMenu()" class="menu-link mega-menu-link">
                            Structure
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" class="menu-link mega-menu-link" aria-haspopup="true">Functions</a>
                          <ul class="menu menu-list">
                            <li>
                              <a [routerLink]="['/aboutdepartment/developmentalfunction']" (click)="closeMenu()" class="menu-link menu-list-link">
                                Developmental Functions
                              </a>
                            </li>
                            <li>
                              <a [routerLink]="['/aboutdepartment/regulatoryfunction']" (click)="closeMenu()" class="menu-link menu-list-link">
                                Regulatory Functions
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="menu-link mega-menu-link" aria-haspopup="true">Budget Allocated</a>
                          <ul class="menu menu-list">
                            <li>
                              <a [routerLink]="['/aboutdepartment/hodwiseallocation']" (click)="closeMenu()" class="menu-link menu-list-link">
                                Budget Allocation
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="menu-link mega-menu-link" aria-haspopup="true">Schemes</a>
                          <ul class="menu menu-list">
                            <li><a [routerLink]="['/aboutdepartment/statescheme']" (click)="closeMenu()" class="menu-link menu-list-link">State Schemes</a></li>
                            <li><a [routerLink]="['/aboutdepartment/ncdcschemes']" (click)="closeMenu()" class="menu-link menu-list-link">NCDC Schemes</a></li>
                            <li><a [routerLink]="['/aboutdepartment/icdp']" (click)="closeMenu()" class="menu-link menu-list-link">ICDP</a></li>
                            <li><a [routerLink]="['/aboutdepartment/planexpenditure']" (click)="closeMenu()" class="menu-link menu-list-link">Plan Expenditure</a></li>
                            <li><a [routerLink]="['/aboutdepartment/govtinvestment']" (click)="closeMenu()" class="menu-link menu-list-link">Govt. Investment</a></li>
                            <li><a [routerLink]="['/aboutdepartment/implemented']" (click)="closeMenu()" class="menu-link menu-list-link">Implemented</a></li>
                          </ul>
                        </li>
                        <li>
                          <a [routerLink]="['/aboutdepartment/telephonedirectory']" (click)="closeMenu()" class="menu-link mega-menu-link">Telephone Directory</a>
                        </li>
                      </ul>
                    </li>
                  
                    <li [class.open]="isOpen(1)" (mouseenter)="setOpen(1)" (mouseleave)="closeMenu()">
                      <a href="javascript:void(0);" class="menu-link menu-bar-link" aria-haspopup="true">
                        <i class="bi bi-grid-1x2-fill"></i> Societies
                      </a>
                      <ul class="mega-menu mega-menu--multiLevel">
                        <li><a href="http://hpscb.com" target="_blank" class="menu-link mega-menu-link">HP State Coop. Bank</a></li>
                        <li><a href="http://hpardb.in" target="_blank" class="menu-link mega-menu-link">ARDB</a></li>
                        <li><a href="http://himfed.com" target="_blank" class="menu-link mega-menu-link">Himfed</a></li>
                        <li><a href="http://www.himbunkar.co.in" target="_blank" class="menu-link mega-menu-link">Himbunker</a></li>
                        <li><a href="https://himachal.nic.in/index.php?lang=1&dpt_id=189" target="_blank" class="menu-link mega-menu-link">Woolfed</a></li>
                        <li><a href="http://hpmilkfed.org" target="_blank" class="menu-link mega-menu-link">HP Milkfed</a></li>
                        <li><a href="http://kccb.in" target="_blank" class="menu-link mega-menu-link">Kangra Central Coop. Bank</a></li>
                        <li><a href="http://jccb.co.in" target="_blank" class="menu-link mega-menu-link">Jogindra Central Coop. Bank</a></li>
                        <li><a href="http://himcapes.org" target="_blank" class="menu-link mega-menu-link">Himcapes</a></li>
                        <li><a href="/CooperativeSocieties" class="menu-link mega-menu-link">PACS and Other Societies</a></li>
                      </ul>
                    </li>
                  
                    <li [class.open]="isOpen(2)" (mouseenter)="setOpen(2)" (mouseleave)="closeMenu()">
                      <a href="javascript:void(0);" class="menu-link menu-bar-link" aria-haspopup="true">
                        <i class="bi bi-motherboard-fill"></i> Society Registration
                      </a>
                      <ul class="mega-menu mega-menu--multiLevel">
                        <li>
                          <a href="javascript:void(0)" class="menu-link mega-menu-link" aria-haspopup="true">Under HP Societies Registration Act, 2006</a>
                          <ul class="menu menu-list">
                            <li><a [routerLink]="['/societyregistration/checklist2006']" (click)="closeMenu()" class="menu-link menu-list-link">Procedure and Checklist</a></li>
                            <li><a [routerLink]="['/login']" (click)="closeMenu()" class="menu-link menu-list-link">Apply Online</a></li>
                            <li><a [routerLink]="['/societyregistration/charitable-societies']" (click)="closeMenu()" class="menu-link menu-list-link">Search Registered Societies</a></li>
                          </ul>
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="menu-link mega-menu-link" aria-haspopup="true">Under HP Cooperative Societies Act, 1968</a>
                          <ul class="menu menu-list">
                            <li><a [routerLink]="['/societyregistration/checklist1968']" (click)="closeMenu()" class="menu-link menu-list-link">Procedure and Checklist</a></li>
                            <li><a [routerLink]="['/login']" (click)="closeMenu()" class="menu-link menu-list-link">Apply Online for Society Registration</a></li>
                            <li><a [routerLink]="['/societyregistration/cooperative-societies']" (click)="closeMenu()" class="menu-link menu-list-link">Search Registered Societies</a></li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  
                    <li [class.open]="isOpen(3)" (mouseenter)="setOpen(3)" (mouseleave)="closeMenu()">
                      <a href="javascript:void(0);" class="menu-link menu-bar-link" aria-haspopup="true">
                        <i class="bi bi-buildings-fill"></i> Court Case(s)
                      </a>
                      <ul class="mega-menu mega-menu--multiLevel">
                        <li><a [routerLink]="['/courtcases/causelist']" (click)="closeMenu()" class="menu-link mega-menu-link">Cause List</a></li>
                        <li><a [routerLink]="['/courtcases/searchcases']" (click)="closeMenu()" class="menu-link mega-menu-link">Search Cases</a></li>
                      </ul>
                    </li>
                  
                    <li [class.open]="isOpen(4)" (mouseenter)="setOpen(4)" (mouseleave)="closeMenu()">
                      <a href="javascript:void(0);" class="menu-link menu-bar-link" aria-haspopup="true">
                        <i class="bi bi-file-earmark-check-fill"></i> Audit
                      </a>
                      <ul class="mega-menu mega-menu--multiLevel">
                            <li>
                          <a [routerLink]="['/audit/societyauditstatus']" class="menu-link mega-menu-link">Society Audit Status</a>
                      </li>
                      <li>
                          <a [routerLink]="['/audit/approvedauditors']" class="menu-link mega-menu-link">Approved Panel of Auditors</a>
                      </li>
                      </ul>
                    </li>
                  
                    <li [class.open]="isOpen(5)" (mouseenter)="setOpen(5)" (mouseleave)="closeMenu()">
                      <a href="javascript:void(0);" class="menu-link menu-bar-link" aria-haspopup="true">
                        <i class="bi bi-binoculars-fill"></i> Action Plan
                      </a>
                      <ul class="mega-menu mega-menu--multiLevel">
                        <li><a [routerLink]="['/actionplan/audit']" (click)="closeMenu()" class="menu-link mega-menu-link">Audit</a></li>
                        <li><a [routerLink]="['/actionplan/inspection']" (click)="closeMenu()" class="menu-link mega-menu-link">Inspection</a></li>
                        <li><a [routerLink]="['/actionplan/enquiry']" (click)="closeMenu()" class="menu-link mega-menu-link">Enquiry</a></li>
                        <li><a [routerLink]="['/actionplan/arbitration']" (click)="closeMenu()" class="menu-link mega-menu-link">Arbitration</a></li>
                        <li><a [routerLink]="['/actionplan/appeals']" (click)="closeMenu()" class="menu-link mega-menu-link">Appeal</a></li>
                        <li><a [routerLink]="['/actionplan/liquidation']" (click)="closeMenu()" class="menu-link mega-menu-link">Liquidation</a></li>
                        <li><a [routerLink]="['/actionplan/registration']" (click)="closeMenu()" class="menu-link mega-menu-link">Registration</a></li>
                      </ul>
                    </li>
                  
                    <li [class.open]="isOpen(6)" (mouseenter)="setOpen(6)" (mouseleave)="closeMenu()">
                      <a href="javascript:void(0);" class="menu-link menu-bar-link" aria-haspopup="true">
                        <i class="bi bi-flag-fill"></i> RTI
                      </a>
                      <ul class="mega-menu mega-menu--multiLevel">
                        <li><a [routerLink]="['/rti/publicinformationofficers']" (click)="closeMenu()" class="menu-link mega-menu-link">Public Information Officers</a></li>
                        <li><a [routerLink]="['/rti/dutiesofofficials']" (click)="closeMenu()" class="menu-link mega-menu-link">Duties of Officials</a></li>
                      </ul>
                    </li>
                  </ul>
                  

                  
        </nav>
      </div>
    </div>
  </div>
</div> 





 -->



<!-- Floating Decorative Elements -->

<style>
  .nav-menu li a {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    padding: 8px 12px;
  }

  .nav-menu li a i {
    font-size: 1.1rem;
  }

  .nav-menu li a:hover {
    color: #ffdd55;
  }

  .announcement-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .announcement-content .left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .announcement-content .right {
    color: #ffc107;
    /* yellow */
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
  }

  /* =========================
   RESET
========================= */
  * {
    box-sizing: border-box;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  /* =========================
   SIDEBAR BASE
========================= */
  .sidebar {
    width: 280px;
    height: 100vh;
    background-color: #1f2a3a;
    color: #cfd8e3;
    display: flex;
    flex-direction: column;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }

  /* =========================
   HEADER / LOGO
========================= */
  .sidebar-header {
    padding: 20px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .logo-icon {
    width: 40px;
    height: 40px;
  }

  .logo-image {
    width: 100%;
    height: auto;
  }

  .logo-text {
    display: flex;
    flex-direction: column;
  }

  .logo-title {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
  }

  .logo-sub {
    font-size: 13px;
    font-weight: 600;
    color: #9ca3af;
  }

  /* =========================
   NAV CONTAINER
========================= */
  .sidebar-nav {
    flex: 1;
    overflow-y: auto;
    padding-top: 10px;
  }

  /* =========================
   NAV ITEMS
========================= */
  .nav-list {
    list-style: none;
  }

  .nav-item {
    width: 100%;
  }

  /* =========================
   LINKS
========================= */
  .nav-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    color: #cfd8e3;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
  }

  .nav-link:hover {
    background: #2b3a4e;
    color: #ffffff;
  }

  /* Active route */
  .active-link {
    background: #314764;
    color: #ffffff;
    border-left: 4px solid #f7b500;
  }

  /* Icons */
  .nav-link i {
    font-size: 16px;
    min-width: 20px;
    text-align: center;
  }

  /* =========================
   PARENT WITH CHILDREN
========================= */
  .has-children {
    width: 100%;
  }

  /* Parent clickable row */
  .parent-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    cursor: pointer;
    color: #cfd8e3;
    transition: background 0.2s ease;
  }

  .parent-link:hover {
    background: #2b3a4e;
  }

  /* Chevron */
  .toggle-icon {
    margin-left: auto;
    font-size: 14px;
    transition: transform 0.3s ease;
  }

  /* Rotate when open */
  .parent-link.expanded .toggle-icon {
    transform: rotate(180deg);
  }

  /* =========================
   SUBMENU
========================= */
  .submenu {
    background: #233145;
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.3s ease;
  }

  /* Show submenu */
  .submenu.open {
    max-height: 800px;
  }

  /* Submenu links */
  .submenu .nav-link {
    padding: 10px 18px 10px 48px;
    font-size: 14px;
  }

  /* Hover */
  .submenu .nav-link:hover {
    background: #2f415c;
  }

  /* Active submenu */
  .submenu .active-link {
    background: #3a5476;
    border-left: 4px solid #f7b500;
  }
.user-avatar {
  font-size: 30px;
  color: #fbbf24; /* yellow color */
  display: block;
}

  /* =========================
   FOOTER / USER
========================= */
  .sidebar-footer {
    padding: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .sidebar-user {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .user-avatar-container {
    width: 40px;
    height: 40px;
  }

  .user-avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .sidebar-user-info {
    display: flex;
    flex-direction: column;
  }

  .sidebar-user-info .name {
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
  }

  .sidebar-user-info .role {
    font-size: 12px;
    color: #9ca3af;
  }
</style>
<div class="floating-shapes">
  <div class="shape shape-1"></div>
  <div class="shape shape-2"></div>
  <div class="shape shape-3"></div>
</div>

<div class="announcement-bar" *ngIf="!isAuthenticated || !currentUser?.certificatePath">
  <div class="container">
    <div class="announcement-content">
      <div class="left">
        <i class="bi bi-megaphone-fill"></i>
        <span>New: Online Society Registration Portal is now live!</span>
        <a [routerLink]="['/societyRegistration']">
          Learn More <i class="bi bi-arrow-right"></i>
        </a>
      </div>

      <div class="right">
        <i class="bi bi-clock"></i>
        {{ currentDate | date:'dd-MM-yyyy HH:mm:ss' }}
      </div>
    </div>
  </div>
</div>

<!-- <header class="main-header" *ngIf="!isAuthenticated">
  <div class="container">
    <nav class="navbar">
      <a href="#" class="brand">
        <div class="emblem">
          <img src="../../assets/images/logos/hplogo.png" alt="HP Logo">
        </div>

        <div class="brand-text">
          <span class="brand-name">Cooperative Department</span>
          <span class="brand-sub">Government of Himachal Pradesh</span>
        </div>
      </a>

      <ul class="nav-menu" id="navMenu">
        <li>
          <a [routerLink]="['/home']" class="active">
            <i class="fa fa-home"></i> Home
          </a>
        </li>

        <li>
          <a [routerLink]="['/aboutus']">
            <i class="fa fa-info"></i> About Us
          </a>
        </li>

        <li>
          <a [routerLink]="['/actrules']">
            <i class="fa fa-briefcase"></i> Services
          </a>
        </li>

        <li>
          <a [routerLink]="['/contact']">
            <i class="fa fa-phone"></i> Contact
          </a>
        </li>

        <li>
          <a routerLink="/calendar">
            <i class="fa fa-calendar"></i> Calendar
          </a>
        </li>


      </ul>

      <div class="nav-actions">
        <button class="lang-toggle">
          <i class="bi bi-translate"></i>
          हिंदी
        </button>
        <a [routerLink]="['/login']" *ngIf="!isAuthenticated" href="login_design.html" class="btn-login">
          <i class="bi bi-person-circle"></i>
          Login
        </a>
        <button class="mobile-toggle" id="mobileToggle">
          <i class="bi bi-list"></i>
        </button>
      </div>
    </nav>
  </div>
</header> -->
<header class="sidebar" *ngIf="isAuthenticated || currentUser?.certificatePath">
  <div class="sidebar-header">
    <div class="logo">
      <div class="logo-icon">
        <img src="../../assets/images/logos/hplogo.png" alt="HP Logo" class="logo-image" />
      </div>
      <div class="logo-text">
        <span class="logo-title">Department of Cooperation</span>
        <span class="logo-sub">Himachal Pradesh</span>
      </div>
    </div>
  </div>

  <nav class="sidebar-nav">
    <ul class="nav-list">
      <li *ngFor="let item of navItems" class="nav-item">

        <!-- NO CHILD -->
        <a *ngIf="!item.children || item.children.length === 0" [routerLink]="item.route" class="nav-link"
          routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
          <i class="bi" [ngClass]="item.icon"></i>
          <span class="nav-label">{{ item.label }}</span>
        </a>

        <!-- HAS CHILDREN -->
        <div *ngIf="item.children?.length" class="has-children">

          <div class="parent-link" [ngClass]="{ expanded: item.expanded }" (click)="item.expanded = !item.expanded">

            <i class="bi" [ngClass]="item.icon"></i>
            <span class="nav-label">{{ item.label }}</span>
            <i class="bi bi-chevron-down toggle-icon"></i>
          </div>

          <!-- SUBMENU -->
          <ul class="submenu" [class.open]="item.expanded">
            <li *ngFor="let child of item.children">
              <a [routerLink]="child.route" class="nav-link" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="bi" [ngClass]="child.icon"></i>
                <span class="nav-label">{{ child.label }}</span>
              </a>
            </li>
          </ul>

        </div>
      </li>

    </ul>
  </nav>

  <!-- <div class="sidebar-footer">
    <div class="sidebar-user">
      <div class="user-avatar-container">
  <i class="bi bi-person-circle user-avatar"></i>
</div>

      <div class="sidebar-user-info">
        <span class="name">{{ userName }}</span>
        <span class="role">{{ roleName }}</span>
      </div>
    </div>
  </div> -->
</header>